/**
 * Generates a Schema.org Service JSON-LD object for individual service pages.
 * Links back to the homepage LocalBusiness entity as the provider.
 */

const provider = {
  "@id": "https://masonry-pro.com",
};

const areaServed = [
  { "@type": "State", "name": "New Jersey" },
  { "@type": "AdministrativeArea", "name": "Passaic County" },
  { "@type": "AdministrativeArea", "name": "Bergen County" },
  { "@type": "AdministrativeArea", "name": "Essex County" },
  { "@type": "AdministrativeArea", "name": "Morris County" },
];

export interface ServiceSchemaConfig {
  name: string;
  description: string;
  url: string; // relative path e.g. "/paving-services/paver-patios"
  image?: string; // absolute URL to hero image
}

export function generateServiceSchema(config: ServiceSchemaConfig) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    "@id": `https://masonry-pro.com${config.url}#service`,
    "name": config.name,
    "description": config.description,
    "url": `https://masonry-pro.com${config.url}`,
    ...(config.image ? { "image": config.image } : {}),
    "provider": provider,
    "areaServed": areaServed,
    "serviceType": config.name,
  };
}
